<template>
  <div class="floating-label-input mt-2 h-32">
    <textarea
      id="message"
      v-model="internalValue.answer"
      class="peer focus:outline-none border-none p-0 h-20"
      :placeholder="internalValue.label"
    ></textarea>
    <label for="textarea" class="">{{ internalValue.label }}</label>
  </div>
</template>

<script >
export default {
  name: "FormTextarea",
  props: {
    modelValue: Object,
  },
  emits: ["update:modelValue"],
  computed: {
    internalValue: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit("update:modelValue", v);
      },
    },
  },
};
</script>
